// extracted by mini-css-extract-plugin
module.exports = {"primaryButton":"TopArea-primaryButton-2K5aZQ","container":"TopArea-container-16RlHb","leftSide":"TopArea-leftSide-gAA-J4","rightSide":"TopArea-rightSide-30vpGe"};